import { useContext } from 'react'
import type { AxiosInstance } from 'axios'
import { axiosContext } from './axios-context'

export const useApi = (): AxiosInstance => {
    const ctx = useContext(axiosContext);

    if (!ctx) {
        throw new Error('useApi must be used within <AxiosApiProvider>')
    }

    return ctx;
};
